import React from 'react';
import PropTypes from 'prop-types';

import './CategoryMenu.sass';

import SideMenu from '../sideMenu/SideMenu';

import cx from 'classnames';
import Menu from '../menu/Menu';
import MainTaxonDropdown from '../../containers/mainTaxonDropdown/MainTaxonDropdown';

export default class CategoryMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {isMenuOpen: false};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.items !== this.props.items) {
      this.setState({isMenuOpen: false});
    }
  }

  render() {
    const {isMenuOpen} = this.state;
    const {title, items, breadcrumbs} = this.props;

    return (
      <div className={cx(
        'category-menu',
        isMenuOpen && 'category-menu--open'
      )}>
        <a className="category-menu__title" href="#" onClick={evt => {
          evt.preventDefault();
          this.setState({isMenuOpen: true});
        }}>
          {title}
        </a>

        <SideMenu
          section
          isOpen={isMenuOpen}
          onStateChange={isMenuOpen => this.setState({isMenuOpen})}
        >
          <div className="category-menu__dropdown">
            {/* TODO: add background overlay when dropdown is active */}
            <MainTaxonDropdown/>
          </div>

          <Menu mobile items={items} breadcrumbs={breadcrumbs}/>
        </SideMenu>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/categoryMenu/CategoryMenu.js